/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-05 09:39:07
 **/

import { useCallback } from "react";
import { useAtomCallback } from "jotai/utils";
//*
import { SoundMeter } from "@/frameworks/core/engine";
/*/
import { SoundMeter } from "@rfice/xms";
//*/

import { JotaiStore } from "@/frameworks/libraries/commons";

import { PhoneCallAtoms } from "@/frameworks/core/hooks";

const LOGTAG = "#useStreamAPI#";

export default function useStreamAPI() {
	// const get_local_stream = useAtomCallback(
	// 	useCallback((get) => {
	// 		return get(PhoneCallAtoms.LocalStream);
	// 	}, []),
	// 	{ store: JotaiStore }
	// );
	//
	// const set_local_stream = useAtomCallback(
	// 	useCallback((get, set, stream: MediaStream | null) => {
	// 		const old_stream = get(PhoneCallAtoms.LocalStream);
	// 		if (old_stream && stream === null) {
	// 			old_stream.getTracks().forEach((track) => track.stop());
	// 			set(PhoneCallAtoms.LocalSoundMeter, null);
	// 			console.debug(LOGTAG, "clear local stream");
	// 		}
	// 		set(PhoneCallAtoms.LocalStream, stream);
	// 	}, []),
	// 	{ store: JotaiStore }
	// );

	const set_local_sound_meter = useAtomCallback(
		useCallback((_, set, stream: SoundMeter | null) => {
			set(PhoneCallAtoms.LocalSoundMeter, stream);
		}, []),
		{ store: JotaiStore }
	);

	const get_remote_stream = useAtomCallback(
		useCallback((get, _, userID: string) => {
			return get(PhoneCallAtoms.RemoteStream(userID));
		}, []),
		{ store: JotaiStore }
	);

	const set_remote_stream = useAtomCallback(
		useCallback((_, set, userID: string, stream: MediaStream | null) => {
			set(PhoneCallAtoms.RemoteStream(userID), stream);
		}, []),
		{ store: JotaiStore }
	);

	const get_remote_screen_stream = useAtomCallback(
		useCallback((get) => {
			return get(PhoneCallAtoms.RemoteScreenStream);
		}, []),
		{ store: JotaiStore }
	);

	const set_remote_screen_stream = useAtomCallback(
		useCallback((get, set, stream: MediaStream | null) => {
			const old_stream = get(PhoneCallAtoms.RemoteScreenStream);
			if (old_stream && stream === null) {
				old_stream.getTracks().forEach((track) => track.stop());
				console.debug(LOGTAG, "clear remote screen stream");
			}
			set(PhoneCallAtoms.RemoteScreenStream, stream);
		}, []),
		{ store: JotaiStore }
	);
	return {
		// get local_stream() {
		// 	return get_local_stream();
		// },
		// set local_stream(value: MediaStream | null) {
		// 	set_local_stream(value);
		// },
		set sound_meter(value: SoundMeter | null) {
			set_local_sound_meter(value);
		},
		get_remote_stream,
		set_remote_stream,
		get remote_screen_stream() {
			return get_remote_screen_stream();
		},
		set remote_screen_stream(value: MediaStream | null) {
			set_remote_screen_stream(value);
		}
	};
}
